import i18next from 'i18next';

i18next.addResources('en', 'privacyLegalTerms', {
  PRIVACY_TITLE: 'Privacy',
  LEGAL_TITLE: 'Legal',
  TERMS_TITLE: 'Terms',
  LAST_UPDATED: 'Last Updated: {{-date}}'
});
